import { useCallback, useEffect, useState } from "react";
import SelectSearchable from "../../SelectSeachble/SelectSearchble";
import ListaClienteSeguro from "../ListaClienteSeguro";
import DatosCliente from "./DatosCliente";
import { GetTokenDecoded } from "../../../utils/storeUsuario";
import { ControllerSchearCliente } from "../../../Service/Service.cliente";
import "../../../styles/FacturaCrear.css";

/* ============================================================================
   CREAR FACTURA · bloque 1, el cliente

   Una tarjeta a todo el ancho en tres franjas: cabecera, datos y -- si falta
   algo -- la franja de aviso (que pinta `ListaClienteSeguro`).

   EL ACORDEÓN "Facturar otros Datos" DESAPARECE COMO SECCIÓN y pasa a ser lo
   que siempre fue: una casilla. Facturar a nombre de un tercero es una
   decisión de sí o no, no un apartado que abrir.

   La carga de clientes y su manejador se MUEVEN aquí desde `DatosFactura`
   sin tocarles una línea: misma llamada, una sola vez, mismo
   `onClienteSeleccionado` hacia arriba.
   ========================================================================== */

export default function TarjetaCliente({ onClienteSeleccionado, handleClienteNew, reloadClientes }) {
    const [clientes, setClientes] = useState([]);
    const [selectedClienteOption, setSelectedClienteOption] = useState(null);
    const [clienteSelectedDetails, setclienteSelectedDetails] = useState(null);
    const [aTercero, setATercero] = useState(false);

    // Copiado tal cual de DatosFactura.
    const handleClienteChange = (selectedOption) => {
        setSelectedClienteOption(selectedOption);
        setclienteSelectedDetails(null);
        if (selectedOption) {
            var clienteSeleccionado = clientes.filter((a) => a.idcliente === selectedOption.value);
            setclienteSelectedDetails(clienteSeleccionado[0]);
            onClienteSeleccionado(selectedOption);
        }
    };

    const fetchClienteData = useCallback(async () => {
        const tokenDecoded = GetTokenDecoded();
        const rCliente = await ControllerSchearCliente(tokenDecoded.idclinica, "");
        if (rCliente && rCliente.success) {
            const cliente = rCliente.data.map((cli) => ({ value: cli.idcliente, label: cli.nombre, ...cli }));
            setClientes(cliente);
        }
    }, []);

    useEffect(() => {
        fetchClienteData();
    }, [fetchClienteData, reloadClientes]);

    return (
        <div className="fcrear__card">
            <div className="fcrear__ch">
                <span className="fcrear__ct">Cliente</span>

                <div className="fcrear__ch-fin">
                    <label className="fcrear__casilla">
                        <input
                            type="checkbox"
                            checked={aTercero}
                            onChange={(e) => setATercero(e.target.checked)}
                        />
                        Facturar a nombre de un tercero
                    </label>
                </div>
            </div>

            <div className="fcrear__cuerpo">
                <ListaClienteSeguro />

                {aTercero && (
                    <div className="fcrear__tercero">
                        <div className="fcrear__campo fcrear__campo--ancho">
                            <span className="fcrear__lab">Cliente a facturar</span>
                            <SelectSearchable
                                listCompany={clientes}
                                handleChange={handleClienteChange}
                                placeholder="Seleccione Cliente"
                                selectedOption={selectedClienteOption}
                                isClearable={true}
                            />
                        </div>

                        <button type="button" className="fcrear__btn" onClick={handleClienteNew}>
                            Agregar cliente
                        </button>

                        {clienteSelectedDetails && (
                            <div className="fcrear__tercero-datos">
                                <DatosCliente info={clienteSelectedDetails} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
